import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

function SoftwareMarketComponent(props) {
  const [availableMarkets, setAvailableMarkets] = useState([]);

  useEffect(() => {
    const request = {
      method: "get",
      headers: {
        accept: "application/json",
      },
    };

    fetch("/api/markets", request)
      .then(response => response.json())
      .then(setAvailableMarkets);
  }, []);

  const handleButtonPress = (marketId) => {
    if (marketId === props.selectedMarket) {
      props.onMarketChange(0);
      return;
    }

    props.onMarketChange(marketId);
  };

  const getMarketName = id => availableMarkets.find(market => market.id === id);

  const getButtonActive = id => (id === props.selectedMarket ? "active" : "");

  const getMarketsForTeam = () => {
    const marketNames = [
      "ERP", "WMS", "CMMS", "HRMS",
    ];

    const marketData = marketNames.map((name) => {
      return availableMarkets.find(market => market.name === name);
    }).filter(data => data !== undefined);

    for (let i = 0; i < marketData.length; i += 1) {
      if (marketData[i].id === props.team.primary_market_id) {
        const data = marketData[i];
        marketData.splice(i, 1);
        marketData.unshift(data);
        break;
      }
    }

    return marketData;
  };

  const countLeadsForMarket = (id) => {
    let total = 0;

    for (let i = 0; i < props.leads.length; i += 1) {
      if (props.leads[i].market_id === id) {
        total += 1;
      }
    }

    if (total > 50) {
      return "50+";
    }

    return total.toString();
  };

  const buttons = [];

  if (props.team) {
    const primaryMarket = getMarketName(props.team.primary_market_id) || { name: '' };

    if (primaryMarket.name === "EHR") {
      buttons.push((
        <button
          key="EHR"
          className={`filter-research ${getButtonActive(props.team.primary_market_id)}`}
          onClick={() => handleButtonPress(props.team.primary_market_id)}
        >
          EHR ({countLeadsForMarket(props.team.primary_market_id)})
        </button>
      ));
    } else {
      getMarketsForTeam().forEach((market) => {
        buttons.push((
          <button
            key={market.name}
            className={`filter-research ${getButtonActive(market.id)}`}
            onClick={() => handleButtonPress(market.id)}
          >
            {market.name} ({countLeadsForMarket(market.id)})
          </button>
        ));
      });
    }
  } else {
    buttons.push((
      <button
        key="loading"
        className="filter-research"
        onClick={() => undefined}
      >
        Loading ...
      </button>
    ));
  }

  return (
    <div>
      <p className="filter-by-research">Filter by market:</p>
      <div className="categories">
        {buttons}
      </div>
    </div>
  );
}

SoftwareMarketComponent.propTypes = {
  team: PropTypes.object,
  leads: PropTypes.array,
  selectedMarket: PropTypes.string,
  onMarketChange: PropTypes.func.isRequired,
};

SoftwareMarketComponent.defaultProps = {
  team: {},
  leads: [],
  selectedMarket: 0,
};

export default SoftwareMarketComponent;
